import React,{useState,useEffect} from 'react'
import './Banner.css'
import axios from './axios';
import requests from './requests';


function Banner() {
    const [movie,setMovie]=useState([]);
    useEffect(()=>{

        async function fetchData(){
const request=await axios.get(requests.fetchTrending);
setMovie(
    request.data.results[
        Math.floor(Math.random()*request.data.results.length -1)
    ]
);return request
        }
        fetchData()
    },[])

    function truncate(str,n){
return str?.length>n ? str.substr(0,n-1)+"...":str
    }
    return (
        <header className="banner"
        style={{
            backgroundSize:"cover",
            backgroundImage:`url("https://image.tmdb.org/t/p/original/${movie?.backdrop_path}")`,
            backgroundPosition:"center center",

        }}
        >
            <div className="banner_content">
                <h1 className="title">
                    {movie?.title || movie?.name || movie?.original_name}
                </h1>
                <div className="buttons">
                    <button className="button">
                        Play
                    </button>
                    <button className="button">
                        My List
                    </button>
                </div>

                <h1 className="description">
                    {truncate(movie?.overview,200)}
                </h1>
                <div className="fadeBottom"></div>

             </div>
            
        </header>
    )
}

export default Banner
